import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ApproveFlyerResponseDto } from "@swagger/typescript-fetch-goflyer";
import { messages } from "../../../../locales/messages";

interface Props {
  open: boolean;
  onClose: () => void;
  onConfirm: (
    publishDate?: string,
  ) => Promise<ApproveFlyerResponseDto | undefined>;
}

export function ApproveDialog({ open, onClose, onConfirm }: Props) {
  const { t } = useTranslation();
  const [publishDate, setPublishDate] = useState("");
  const [busy, setBusy] = useState(false);

  const handleApprove = async () => {
    setBusy(true);
    const result = await onConfirm(publishDate || undefined);
    setBusy(false);
    if (result) {
      setPublishDate("");
      onClose();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={busy ? undefined : onClose}
      data-testid="approve-dialog"
    >
      <DialogTitle>{t(messages.Approve())}</DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 1 }}>
          <TextField
            size="small"
            fullWidth
            type="datetime-local"
            label={t(messages.Publish_Date())}
            InputLabelProps={{ shrink: true }}
            value={publishDate}
            onChange={(e) => setPublishDate(e.target.value)}
            data-testid="approve-publish-date"
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={busy}>
          {t(messages.Cancel())}
        </Button>
        <Button
          variant="contained"
          onClick={handleApprove}
          disabled={busy}
          sx={{
            backgroundColor: "#f58220",
            "&:hover": { backgroundColor: "#e8722e" },
          }}
          data-testid="approve-confirm"
        >
          {t(messages.Approve())}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
